import { createSlice } from "@reduxjs/toolkit";

// Market Deepdive's period grain and From / To range. They live here rather
// than in the page's local filter object because that object resets on every
// market change and the grain must survive one; both reset only when the
// workspace changes.
const initialState = {
  // 'month' | 'quarter' | 'year'
  period: "month",
  // { start, end } as YYYYMM numbers covering whole periods, or null for the
  // market's whole history
  dateRange: null,
};

const marketDeepdiveSlice = createSlice({
  name: "marketDeepdive",
  initialState,
  reducers: {
    // A range picked in one grain says nothing about the next, so it clears
    // with the grain.
    setPeriod: (state, action) => {
      state.period = action.payload;
      state.dateRange = null;
    },
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    resetForWorkspaceChange: (state) => {
      state.period = "month";
      state.dateRange = null;
    },
  },
});

export const { setPeriod, setDateRange, resetForWorkspaceChange } = marketDeepdiveSlice.actions;

export const selectDeepdivePeriod = (state) => state.marketDeepdive?.period ?? "month";
export const selectDeepdiveDateRange = (state) => state.marketDeepdive?.dateRange ?? null;

export default marketDeepdiveSlice.reducer;
